<style>
.termo-container {
    border: 2px solid #666;
    border-radius: 5px;
    margin-bottom: 15px;
    background: #EEE;
}

.termo-pendente {
    cursor: pointer;
}

.termo-container.termo-pendente:hover {
    background: rgba(0, 0, 0, 0.2)
}

.termo-container.termo-pendente.selected {
    border: 3px solid #002B82;
    background: #FFF;
    cursor: default;
}

.action-btn-container {
    display: flex;
    justify-content: space-around;
}

.endereco-table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 15px !important;
}

.endereco-table td {
    padding: 3px 5px;
    border: 1px solid #728cc0;
}

.endereco-table td.label {
    text-align: left;
    font-weight: bold;
    font-size: 10pt;
    text-transform: uppercase;
    border-right: none;
}

.endereco-table td.info {
    border-left: none;
    text-align: center;
}

.endereco-table tr:last-child td:last-child {
    border-bottom: none;
    border-right: none;
}

.endereco-table tr:last-child td:first-child {
    border-bottom: none;
    border-left: none;
}

.title-table td {
    background: #002B82;
    color: #FFF;
    text-align: center;
    vertical-align: middle;
    height: 35px;
}

.title-table td:first-child {
    text-align: left;
    padding-left: 10px;
}

.title-table td:last-child {
    text-align: right;
    padding-right: 10px;
}
</style>

<template>
    <div class="card card-plain"
        style="margin: 0 auto; max-width: 500px; background: #FFF; -webkit-box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75); -moz-box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75); box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75);">

        <div class="pb-0 card-header text-start">
            <h4 class="font-weight-bolder">Meus termos</h4>

            <div v-if="selectedView == 'pendentes'">
                <p class="mb-0" style="line-height: 1.3" v-if="termosPendentes.length == 0">
                    Aqui você pode consultar os termos relacionados aos seus contratos e assinar os termos pendentes.
                </p>
                <p class="mb-0" style="line-height: 1.3" v-if="termosPendentes.length == 1">
                    Você possui um termo pendente de assinatura. Por favor, baixe, leia e assine o termo, caso estiver
                    de acordo.
                </p>
                <p class="mb-0" style="line-height: 1.3" v-if="termosPendentes.length > 1">
                    Você possui termos pendentes de assinatura. Por favor, selecione o termo que deseja visualizar e
                    assinar.
                </p>
            </div>

            <div v-if="selectedView == 'assinados'">
                <p class="mb-0" style="line-height: 1.3">
                    Aqui você pode consultar os termos que já foram assinados, relacionados aos seus contratos.
                </p>
            </div>

        </div>

        <div class="card-body" style="padding-bottom: 10px; padding-top: 10px;">

            <div v-if="selectedView == 'pendentes'">
                <h5>Termos pendentes (<span style="font-size: 13pt;">{{ termosPendentes.length }}</span>):</h5>

                <div v-if="termosPendentes.length == 0" class="bg-info text-light rounded">
                    Você não possui termos pendentes.
                </div>

                <div style="max-height: 40vh; overflow-y: auto;">
                    <div v-for="(termo, index) in termosPendentes" :key="index">
                        <div @click="selecionarTermo(termo)" class="termo-container termo-pendente p-2"
                            :class="termoSelecionado == termo.id ? 'selected' : ''">

                            <table style="width: 100%;">
                                <tr>
                                    <td style="font-size: 11pt;">
                                        <b>Contrato #{{ termo.id_contrato }}</b>
                                    </td>
                                    <td style="font-size: 11pt;">
                                        <b>{{ termo.nome_termo }}</b>
                                    </td>
                                    <td>
                                        <font-awesome-icon v-if="termoSelecionado == termo.id"
                                            icon="fa-solid fa-chevron-up" />

                                        <font-awesome-icon v-else icon="fa-solid fa-chevron-down" />
                                    </td>
                                </tr>
                            </table>

                            <div v-if="termoSelecionado == termo.id">
                                <div class="horizontal-divider my-2"></div>

                                <div class="action-btn-container">

                                    <button class="btn btn-sm btn-primary mb-0"
                                        @click="baixarTermo(termo, false)">BAIXAR
                                        TERMO</button>

                                    <button class="btn btn-sm btn-primary mb-0"
                                        :disabled="!termosBaixados.includes(termo.id)"
                                        @click="confirmAssinarTermo(termo)">ASSINAR</button>

                                </div>

                                <div class="horizontal-divider my-2"></div>

                                <div class="px-2" style="font-size: 11pt; text-align: justify;">
                                    Após <strong>baixar</strong>, <strong>ler</strong> e <strong>conferir</strong> o
                                    termo,
                                    clique em "<strong>ASSINAR</strong>" para concluir a assinatura.
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="horizontal-divider mb-3"></div>

                <button class="btn btn-sm btn-dark btn-primary mb-2" @click="setSelectedView('assinados')">
                    <font-awesome-icon icon="fa-solid fa-pen-to-square" class="me-1" /> EXIBIR TERMOS ASSINADOS ({{
                        termosAssinados.length }})
                </button>
            </div>

            <div v-if="selectedView == 'assinados'">
                <h5>Termos assinados (<span style="font-size: 13pt;">{{ termosAssinados.length }}</span>):</h5>

                <div v-if="termosAssinados.length == 0" class="bg-info text-light rounded">
                    Você não possui termos assinados.
                </div>

                <div style="max-height: 40vh; overflow-y: auto;">
                    <div v-for="(termo, index) in termosAssinados" :key="index">
                        <div class="termo-container p-2" :class="termoSelecionado == termo.id ? 'selected' : ''">

                            <table style="width: 100%;">
                                <tr>
                                    <td style="font-size: 11pt;">
                                        <b>Contrato #{{ termo.id_contrato }}</b>
                                    </td>
                                    <td style="font-size: 11pt;">
                                        <b>{{ termo.nome_termo }}</b>
                                    </td>
                                    <td class="text-success">
                                        <font-awesome-icon icon="fa-solid fa-check" />
                                    </td>
                                </tr>
                            </table>

                            <div class="horizontal-divider my-2"></div>

                            <div class="action-btn-container">

                                <button class="btn btn-sm btn-primary mb-0" @click="baixarTermo(termo, true)">BAIXAR
                                    TERMO</button>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="horizontal-divider mb-3"></div>

                <button class="btn btn-sm btn-dark btn-primary mb-2" @click="setSelectedView('pendentes')">
                    <font-awesome-icon icon="fa-solid fa-eye" class="me-1" /> EXIBIR TERMOS PENDENTES ({{
                        termosPendentes.length }})
                </button>
            </div>

        </div>
        <div class="px-1 pt-0 text-center card-footer px-lg-2">
            <p class="mx-auto text-sm">
                Dúvidas?
                <a href="https://api.whatsapp.com/send?phone=553537311118" target="_blank"
                    class="text-warning text-gradient font-weight-bold">Entre em contato pelo WhatsApp</a>
            </p>
            <button class="btn btn-light btn-sm mb-0" @click="voltar">SAIR</button>
        </div>
    </div>
</template>

<script>
// import ArgonButton from "@/components/ArgonButton.vue";
const body = document.getElementsByTagName("body")[0];
import { reactive } from 'vue'
import api from "../services/api.js";
import { downloadPdf, errorMessage } from '../helpers/helper.js'

let selectedView = 'pendentes'

let termos = []
let termoSelecionado = null
const termosBaixando = reactive([])
const termosAssinando = reactive([])
const termosBaixados = reactive([])

export default {
    name: "Termos",
    components: {
        // ArgonButton
    },
    methods: {
        setSelectedView(view) {
            this.selectedView = view
        },
        async refreshTermos() {
            const termos = await api.getTermos()
            if (termos) {
                this.termos = termos

                // Seleciona o termo pendente automaticamente, caso houver apenas 1
                if (this.termosPendentes.length == 1)
                    this.selecionarTermo(this.termosPendentes[0])
            }

        },
        selecionarTermo(termo) {
            console.log('termo:', termo)
            this.termoSelecionado = termo.id
        },
        async baixarTermo(termo, alreadySigned = false) {
            this.termosBaixando.push(termo.id)
            const base64Termo = await api.getPdf(termo.id)
            this.termosBaixando = this.termosBaixando.filter(id => id !== termo.id)

            if (!base64Termo)
                return false

            const termoFilename = 'Contrato #' + termo.id_contrato + ' - ' + termo.nome_termo + ' #' + termo.id + '.pdf'
            downloadPdf(termoFilename, base64Termo)

            this.termosBaixados.push(termo.id)

            if (!alreadySigned)
                this.$swal({
                    icon: 'success',
                    title: 'Termo baixado',
                    html: 'O termo foi salvo no seu dispositivo.<br>Por favor, abra o documento, leia e confira as informações presentes no termo.',
                })
        },
        async confirmAssinarTermo(termo) {
            if (!this.termosBaixados.includes(termo.id)) {
                this.$swal({
                    text: 'É necessário baixar e conferir o termo, antes de assiná-lo.'
                })

                return false
            }

            this.$swal({
                title: 'Confirmação',
                html: 'Você deseja realmente confirmar a assinatura do termo?<br>Antes de confirmar, leia o termo e certifique-se de que todas as informações estão corretas.',
                showCancelButton: true,
                cancelButtonText: 'Não',
                confirmButtonText: 'Sim, desejo assinar'
            })
                .then((result) => {
                    if (result.isConfirmed)
                        this.assinarTermo(termo)
                })

        },
        async assinarTermo(termo) {
            if (!this.termosBaixados.includes(termo.id)) {
                this.$swal({
                    text: 'É necessário baixar e conferir o termo, antes de assiná-lo.'
                })

                return false
            }

            this.termosAssinando.push(termo.id)
            const assinatura = await api.assinarTermo(termo.id)
            this.termosAssinando = this.termosAssinando.filter(id => id !== termo.id)

            if (assinatura)
                this.$swal({
                    icon: 'success',
                    html: 'O termo foi assinado com sucesso!'
                })
                    .then(async () => {
                        await this.refreshTermos()
                    })
            else
                errorMessage(this, 'Ocorreu um erro ao assinar o termo.')


        },
        voltar() {
            this.$swal({
                title: 'Confirmação',
                html: 'Você deseja realmente sair?',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
            })
                .then((result) => {
                    if (result.isConfirmed)
                        this.$router.push({ name: 'Inicio' })
                })
        },
    },
    data() {
        return {
            termos,
            termoSelecionado,
            termosBaixados,
            termosBaixando,
            termosAssinando,
            selectedView,
        }
    },
    computed: {
        termosAssinados() {
            return this.termos.filter(termo => termo.assinado === 'S');
        },
        termosPendentes() {
            return this.termos.filter(termo => termo.assinado === 'N');
        }
    },
    async beforeMount() {
        await this.refreshTermos()
    },
    created() {
        this.$store.state.hideConfigButton = true;
        this.$store.state.showNavbar = false;
        this.$store.state.showSidenav = false;
        this.$store.state.showFooter = false;
        body.classList.remove("bg-gray-100");
    },
    beforeUnmount() {
        this.$store.state.hideConfigButton = false;
        this.$store.state.showNavbar = true;
        this.$store.state.showSidenav = true;
        this.$store.state.showFooter = true;
        body.classList.add("bg-gray-100");
    },
};
</script>